(function () {
  function init(item) {
    if (item._lm) return; item._lm = true;
    var mega = item.querySelector('[data-lm-mega]'); if (!mega) return;
    var img = mega.querySelector('[data-lm-mega-img]'), cap = mega.querySelector('[data-lm-mega-cap]');
    var feature = mega.querySelector('.lm-mega__feature');
    var preloaded = {};
    function show(a) {
      if (!img) return;
      mega.querySelectorAll('a.is-hot').forEach(function (x) { x.classList.remove('is-hot'); });
      var src = a ? a.getAttribute('data-img') : img.getAttribute('data-default');
      if (a) a.classList.add('is-hot');
      if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      cap.textContent = a ? 'Ver ' + a.getAttribute('data-label') : cap.getAttribute('data-default');
      feature.setAttribute('href', a ? a.getAttribute('href') : item.querySelector('.lm-mega-top').getAttribute('href'));
    }
    mega.querySelectorAll('a[data-img]').forEach(function (a) {
      a.addEventListener('mouseenter', function () { show(a); });
      a.addEventListener('focus', function () { show(a); });
    });
    item.addEventListener('mouseenter', function () {
      if (preloaded.done) return; preloaded.done = true;
      mega.querySelectorAll('a[data-img]').forEach(function (a) { var i = new Image(); i.src = a.getAttribute('data-img'); });
    });
    item.addEventListener('mouseleave', function () { show(null); item.classList.remove('is-open'); });
    item.addEventListener('keydown', function (e) { if (e.key === 'Escape') { item.classList.remove('is-open'); item.querySelector('.lm-mega-top').focus(); } });
  }
  function boot() { document.querySelectorAll('.lm-mega-item').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();